import {isEmpty, get, includes} from 'lodash'
import { DisplayReceipt } from '../pages/components/ReceiptBody';

const paymentMethodMap = {
    'apple_pay': 'Apple Pay',
    'google_pay': 'Google Pay'
}

export const getPaymentStatus = (_invoice) => {
    const paymentStatus = _invoice.meta.status;
    return hasReceipts(_invoice) && getDueAmount(_invoice) === 0 ? 'paid' : paymentStatus;
}

export const shouldShowPayButton = function (invoice: any) {
    return isPayable(invoice);
};

export const shouldShowPaymentNotification = function (invoice: any) {
    return shouldShowPayButton(invoice) && invoice.latest_payment_notification;
};

const getDueAmount = (_invoice: any) => {
    let due = _invoice.meta.due_amount;
    const receipts = getReceipts(_invoice);
    if (isEmpty(receipts)) {
        return due;
    }

    due = receipts.reduce(function (subTotal, receipt) {
        return subTotal - receipt.payment_details.amount_received;
    }, due);
    return due > 0 ? due : 0;
}

const hasReceipts = (_invoice) => {
    return !isEmpty(getReceipts(_invoice));
}

const getReceipts = (_invoice) => {
    const originalReceipts = _invoice.receipts === null ? [] : _invoice.receipts;
    return originalReceipts
};

export const isPayable = (_invoice) => {
    const paymentOptions = get(_invoice, 'payment_options', []);
    return !hasReceipts(_invoice) &&
        includes(paymentOptions.map(paymentOption => paymentOption.type), 'creditCard') &&
        get(_invoice, ['options', 'allow_online_payment'], true) &&
        get(_invoice, ['meta', 'due_amount'], 0) > 0;
};

export const invoiceOverdue = (_invoice) =>{
    return Math.sign(_invoice.daysDue) === -1;
}

export const invoicePaid = _invoice => {
    return _invoice.dueAmount <= 0 || ['PAID', 'Closed'].includes(_invoice.status);
};

export const getDisplayReceipts = (invoice: any): Array<DisplayReceipt> => {
    function isPaidByCreditCard(paymentMethod: string): boolean {
        return paymentMethod.toUpperCase() === 'CREDIT_CARD';
    }

    function isPaidByGoogleOrApplePay(paymentMethod: string): boolean {
        return paymentMethod === 'apple_pay' || paymentMethod === 'google_pay';
    }

    return invoice.receipts.map(receipt => {
        const paymentMethod = receipt.payment_method;
        const isPaidByPaymentSelector = isPaidByCreditCard(paymentMethod);
        const isPaidByGooleOrApplePay = isPaidByGoogleOrApplePay(paymentMethod);
        const isDirectDebit = paymentMethod.toUpperCase() === 'DIRECT_DEBIT';
        let paymentMethodCardType = paymentMethod;
        if (isPaidByPaymentSelector) {
            paymentMethodCardType = receipt[paymentMethod].card_details.type.toUpperCase();
        } else if (isPaidByGooleOrApplePay) {
            paymentMethodCardType = paymentMethodMap[paymentMethod];
        } else if (isDirectDebit) {
            paymentMethodCardType = 'DIRECT DEBIT';
        }
        return {
            invoiceNumber: invoice.meta.number,
            details: {
                referenceNumber: receipt[paymentMethod].transaction_details.reference_number,
                dateOfPayment: new Date(receipt.payment_date),
                amount: receipt.payment_details.amount_received,
                companyName: invoice.company.name,
                isBulkPayment: receipt.isBulkPayment,
                paymentMethodCardName: isPaidByPaymentSelector && receipt[paymentMethod].card_details.name,
                paymentMethodCardNumber: isPaidByPaymentSelector && receipt[paymentMethod].card_details.number,
                paymentMethodCardType: paymentMethodCardType,
                invoiceAmount: receipt.payment_details.invoice_amount,
                surchargingAmount: receipt.payment_details.surcharging_amount,
                isSurchargingEnabled: receipt.payment_details.surcharging_enabled
            }
        };
    })
}
